import { z } from 'zod'

// GET /api/bug-management-report-key: the project's bug-report webhook key metadata. The key itself is never readable.
export const BugReportKeyStatusSchema = z.object({
  key: z.object({ prefix: z.string(), created_at: z.string() }).nullable(),
  // Reports accepted without a credential. Null when there were none.
  unauthenticated: z.object({ count: z.number(), last_at: z.string() }).nullable(),
})
export type BugReportKeyStatus = z.infer<typeof BugReportKeyStatusSchema>

// POST /api/bug-management-report-key: a fresh key, shown once, embedded in the webhook URL.
export const RotatedBugReportKeySchema = z.object({ webhook_url: z.string() })
export type RotatedBugReportKey = z.infer<typeof RotatedBugReportKeySchema>
